<template>
  <div
    v-update-scroll-size
    class="wrapper"
  >
    <VirtualList
      id="vList"
      ref="vList"
      v-scroll-bottom
      :variable="getMessageCellHeight"
      :start="startIndex"
      :size="minHeight"
      :remain="remain"
      :bench="bench"
      :totop="onFetchingMessages"
    >
      <MessageCell
        v-for="(item) in allMessages"
        :key="item.id"
        :message="item"
        @imgClicked="onImgClicked"
        @loadImage="onLoadImage"
      />
    </VirtualList>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VirtualList from 'vue-virtual-scroll-list'
import MessageCell from './MessageCell'
import _ from 'lodash'

export default {
  name: 'MessageTable',
  components: { VirtualList, MessageCell },
  directives: {
    'update-scroll-size': {
      inserted: function (el, binding, vnode) {
        const self = vnode.context
        const remain = Math.floor(el.scrollHeight / self.minHeight)
        self.remain = remain
        self.bench = remain
      }
    },
    'scroll-bottom': {
      componentUpdated: function (el) {
        requestAnimationFrame(() => {
          el.scrollTop = el.children[0].scrollHeight
          setTimeout(() => {
            el.scrollTop = el.children[0].scrollHeight
          }, 50)
        })
      }
    }
  },
  data: function () {
    return {
      minHeight: 36,
      remain: 8,
      bench: 5,
      startIndex: 0
    }
  },
  computed: {
    ...mapGetters({
      allMessages: 'message/getAllMessages',
      contactAvatar: 'messageDrawer/getContactAvatar',
      selfAvatar: 'message/getSelfAvatar',
      isForcedScrollBottom: 'messageDrawer/getForcedScrollBottom'
    }),
    forcedScrollBottom: {
      get: function () {
        return this.isForcedScrollBottom
      },
      set: function (val) {
        this.setForcedScrollBottom({ val })
      }
    }
  },
  watch: {
    allMessages: function () {
      // Fix the rendering bug when (remain + bench) is greater than the total data
      const vList = this.$refs.vList
      if (this.allMessages.length <= vList.remain + vList.bench) {
        vList.forceRender()
      }
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.debouncedScrollBottom = _.debounce(this.onScrollBottom, 300)
    this.handleResize()
  },
  destroyed () {
    this.resetMessages()
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    ...mapActions({
      resetMessages: 'message/reset',
      setForcedScrollBottom: 'messageDrawer/setForcedScrollBottom'
    }),
    onFetchingMessages () {
      // console.log('fetch messages')
    },
    onImgClicked (imgUrl) {
      this.$emit('imgClicked', imgUrl)
    },
    getMessageCellHeight (index) {
      return _.get(this.allMessages[index], 'height', 30)
    },
    handleResize () {

    },
    onLoadImage () {
      this.debouncedScrollBottom()
    },
    onScrollBottom () {
      if (this.forcedScrollBottom) {
        requestAnimationFrame(() => {
          const scroller = document.getElementById('vList')
          if (!scroller) return
          scroller.scrollTop = scroller.children[0].scrollHeight
          setTimeout(() => {
            scroller.scrollTop = scroller.children[0].scrollHeight
            this.forcedScrollBottom = false
          }, 50)
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .main{
    position: relative;
    overflow: hidden;
    height: 100%;
  }
  .wrapper {
    overflow: auto;
    padding: 0px 15px 0px 15px;

    height: 100%;
    .inner-wrapper {
      height: 100%;
      overflow: auto;
    }
  }
  .scroller {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    min-height: 100%;
    padding: 10px 15px;
  }
  .avatar {
    float: left;
    margin: 0 10px 0 0;
    border-radius: 50%;
  }
  .time {
    margin: 7px 7px;
    text-align: center;
    > span {
      display: inline-block;
      padding: 0 18px;
      font-size: 12px;
      color: #fff;
      border-radius: 2px;
      background-color: #dcdcdc;
    }
  }
  .self {
    text-align: right;
    .avatar {
      float: right;
      margin: 0 0 0 10px;
    }
  }
</style>
